export default __webpack_public_path__ + "ce518cfae01f6fcc536a1f2a141d24de.png";